import { render, staticRenderFns } from "./ivstchs.vue?vue&type=template&id=627b9f0a&scoped=true"
import script from "./ivstchs.vue?vue&type=script&lang=js"
export * from "./ivstchs.vue?vue&type=script&lang=js"
import style0 from "./ivstchs.vue?vue&type=style&index=0&id=627b9f0a&prod&scoped=true&lang=css"
import style1 from "./ivstchs.vue?vue&type=style&index=1&id=627b9f0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b9f0a",
  null
  
)

export default component.exports